import React from 'react'
import { connect } from 'react-redux'
import { bool, func } from 'prop-types'
import MetaData from '../../SearchContent/MetaData'
import AddressContainer from '../../SearchContent/AddressContainer'
import { toggleSearchContentFooter } from '../../../../store/Actions/UiActions'

const SmallInfoContainer = ({ toggleStatus, toggleSearchContentFooter }) =>
  !toggleStatus && (
    <div
      className="post-search-footer"
      onClick={() => toggleSearchContentFooter(!toggleStatus)}
    >
      <AddressContainer />
      <MetaData />
    </div>
  )

SmallInfoContainer.propTypes = {
  toggleStatus: bool.isRequired,
  toggleSearchContentFooter: func.isRequired,
}

const mapStateToProps = ({ ui }) => ({
  toggleStatus: ui.searchContentFooter,
})

const mapDispatchToProps = dispatch => ({
  toggleSearchContentFooter: value =>
    dispatch(toggleSearchContentFooter(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SmallInfoContainer)



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/PostSearch/SmallInfoContainer.jsx